class OrderPending {
	constructor() {
		const { Cookie } = window.od;

		Cookie.set('orderPending', 'true', 0.00694444444);
	}
}

export default OrderPending;
